/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DevViewerOverlaysRouteImport } from './routes/dev.viewer-overlays'
import { Route as DevDesignSystemRouteImport } from './routes/dev.design-system'
import { Route as DevChatPreviewRouteImport } from './routes/dev.chat-preview'
import { Route as DevAppShellPreviewRouteImport } from './routes/dev.app-shell-preview'
import { Route as DevAiSuggestionsPreviewRouteImport } from './routes/dev.ai-suggestions-preview'
import { Route as AuthenticatedWorkspacesRouteImport } from './routes/_authenticated/workspaces'
import { Route as AuthenticatedUploadsRouteImport } from './routes/_authenticated/uploads'
import { Route as AuthenticatedPromptsRouteImport } from './routes/_authenticated/prompts'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects/index'
import { Route as AuthenticatedDocfillerIndexRouteImport } from './routes/_authenticated/docfiller/index'
import { Route as PublicDocfillerShareTokenRouteImport } from './routes/public.docfiller.$shareToken'
import { Route as AuthenticatedDocfillerChatsRouteImport } from './routes/_authenticated/docfiller/chats'
import { Route as AuthenticatedDocfillerDocumentIdRouteImport } from './routes/_authenticated/docfiller/$documentId'
import { Route as AuthenticatedProjectsProjectSlugIndexRouteImport } from './routes/_authenticated/projects/$projectSlug/index'
import { Route as AuthenticatedProjectsWorkspaceUuidProjectUuidRouteImport } from './routes/_authenticated/projects/$workspaceUuid/$projectUuid'
import { Route as AuthenticatedProjectsProjectSlugPromptsRouteImport } from './routes/_authenticated/projects/$projectSlug/prompts'
import { Route as AuthenticatedProjectsProjectSlugMembersRouteImport } from './routes/_authenticated/projects/$projectSlug/members'
import { Route as AuthenticatedProjectsProjectSlugContextRouteImport } from './routes/_authenticated/projects/$projectSlug/context'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevViewerOverlaysRoute = DevViewerOverlaysRouteImport.update({
  id: '/dev/viewer-overlays',
  path: '/dev/viewer-overlays',
  getParentRoute: () => rootRouteImport,
} as any)
const DevDesignSystemRoute = DevDesignSystemRouteImport.update({
  id: '/dev/design-system',
  path: '/dev/design-system',
  getParentRoute: () => rootRouteImport,
} as any)
const DevChatPreviewRoute = DevChatPreviewRouteImport.update({
  id: '/dev/chat-preview',
  path: '/dev/chat-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const DevAppShellPreviewRoute = DevAppShellPreviewRouteImport.update({
  id: '/dev/app-shell-preview',
  path: '/dev/app-shell-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const DevAiSuggestionsPreviewRoute = DevAiSuggestionsPreviewRouteImport.update({
  id: '/dev/ai-suggestions-preview',
  path: '/dev/ai-suggestions-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWorkspacesRoute = AuthenticatedWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUploadsRoute = AuthenticatedUploadsRouteImport.update({
  id: '/uploads',
  path: '/uploads',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPromptsRoute = AuthenticatedPromptsRouteImport.update({
  id: '/prompts',
  path: '/prompts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDocfillerIndexRoute =
  AuthenticatedDocfillerIndexRouteImport.update({
    id: '/docfiller/',
    path: '/docfiller/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const PublicDocfillerShareTokenRoute =
  PublicDocfillerShareTokenRouteImport.update({
    id: '/public/docfiller/$shareToken',
    path: '/public/docfiller/$shareToken',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedDocfillerChatsRoute =
  AuthenticatedDocfillerChatsRouteImport.update({
    id: '/docfiller/chats',
    path: '/docfiller/chats',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDocfillerDocumentIdRoute =
  AuthenticatedDocfillerDocumentIdRouteImport.update({
    id: '/docfiller/$documentId',
    path: '/docfiller/$documentId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectSlugIndexRoute =
  AuthenticatedProjectsProjectSlugIndexRouteImport.update({
    id: '/projects/$projectSlug/',
    path: '/projects/$projectSlug/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsWorkspaceUuidProjectUuidRoute =
  AuthenticatedProjectsWorkspaceUuidProjectUuidRouteImport.update({
    id: '/projects/$workspaceUuid/$projectUuid',
    path: '/projects/$workspaceUuid/$projectUuid',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectSlugPromptsRoute =
  AuthenticatedProjectsProjectSlugPromptsRouteImport.update({
    id: '/projects/$projectSlug/prompts',
    path: '/projects/$projectSlug/prompts',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectSlugMembersRoute =
  AuthenticatedProjectsProjectSlugMembersRouteImport.update({
    id: '/projects/$projectSlug/members',
    path: '/projects/$projectSlug/members',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectSlugContextRoute =
  AuthenticatedProjectsProjectSlugContextRouteImport.update({
    id: '/projects/$projectSlug/context',
    path: '/projects/$projectSlug/context',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/account': typeof AuthenticatedAccountRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/prompts': typeof AuthenticatedPromptsRoute
  '/uploads': typeof AuthenticatedUploadsRoute
  '/workspaces': typeof AuthenticatedWorkspacesRoute
  '/dev/ai-suggestions-preview': typeof DevAiSuggestionsPreviewRoute
  '/dev/app-shell-preview': typeof DevAppShellPreviewRoute
  '/dev/chat-preview': typeof DevChatPreviewRoute
  '/dev/design-system': typeof DevDesignSystemRoute
  '/dev/viewer-overlays': typeof DevViewerOverlaysRoute
  '/docfiller/$documentId': typeof AuthenticatedDocfillerDocumentIdRoute
  '/docfiller/chats': typeof AuthenticatedDocfillerChatsRoute
  '/public/docfiller/$shareToken': typeof PublicDocfillerShareTokenRoute
  '/docfiller/': typeof AuthenticatedDocfillerIndexRoute
  '/projects/': typeof AuthenticatedProjectsIndexRoute
  '/projects/$projectSlug/context': typeof AuthenticatedProjectsProjectSlugContextRoute
  '/projects/$projectSlug/members': typeof AuthenticatedProjectsProjectSlugMembersRoute
  '/projects/$projectSlug/prompts': typeof AuthenticatedProjectsProjectSlugPromptsRoute
  '/projects/$workspaceUuid/$projectUuid': typeof AuthenticatedProjectsWorkspaceUuidProjectUuidRoute
  '/projects/$projectSlug/': typeof AuthenticatedProjectsProjectSlugIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/account': typeof AuthenticatedAccountRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/prompts': typeof AuthenticatedPromptsRoute
  '/uploads': typeof AuthenticatedUploadsRoute
  '/workspaces': typeof AuthenticatedWorkspacesRoute
  '/dev/ai-suggestions-preview': typeof DevAiSuggestionsPreviewRoute
  '/dev/app-shell-preview': typeof DevAppShellPreviewRoute
  '/dev/chat-preview': typeof DevChatPreviewRoute
  '/dev/design-system': typeof DevDesignSystemRoute
  '/dev/viewer-overlays': typeof DevViewerOverlaysRoute
  '/docfiller/$documentId': typeof AuthenticatedDocfillerDocumentIdRoute
  '/docfiller/chats': typeof AuthenticatedDocfillerChatsRoute
  '/public/docfiller/$shareToken': typeof PublicDocfillerShareTokenRoute
  '/docfiller': typeof AuthenticatedDocfillerIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/projects/$projectSlug/context': typeof AuthenticatedProjectsProjectSlugContextRoute
  '/projects/$projectSlug/members': typeof AuthenticatedProjectsProjectSlugMembersRoute
  '/projects/$projectSlug/prompts': typeof AuthenticatedProjectsProjectSlugPromptsRoute
  '/projects/$workspaceUuid/$projectUuid': typeof AuthenticatedProjectsWorkspaceUuidProjectUuidRoute
  '/projects/$projectSlug': typeof AuthenticatedProjectsProjectSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/_authenticated/account': typeof AuthenticatedAccountRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/prompts': typeof AuthenticatedPromptsRoute
  '/_authenticated/uploads': typeof AuthenticatedUploadsRoute
  '/_authenticated/workspaces': typeof AuthenticatedWorkspacesRoute
  '/dev/ai-suggestions-preview': typeof DevAiSuggestionsPreviewRoute
  '/dev/app-shell-preview': typeof DevAppShellPreviewRoute
  '/dev/chat-preview': typeof DevChatPreviewRoute
  '/dev/design-system': typeof DevDesignSystemRoute
  '/dev/viewer-overlays': typeof DevViewerOverlaysRoute
  '/_authenticated/docfiller/$documentId': typeof AuthenticatedDocfillerDocumentIdRoute
  '/_authenticated/docfiller/chats': typeof AuthenticatedDocfillerChatsRoute
  '/public/docfiller/$shareToken': typeof PublicDocfillerShareTokenRoute
  '/_authenticated/docfiller/': typeof AuthenticatedDocfillerIndexRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/projects/$projectSlug/context': typeof AuthenticatedProjectsProjectSlugContextRoute
  '/_authenticated/projects/$projectSlug/members': typeof AuthenticatedProjectsProjectSlugMembersRoute
  '/_authenticated/projects/$projectSlug/prompts': typeof AuthenticatedProjectsProjectSlugPromptsRoute
  '/_authenticated/projects/$workspaceUuid/$projectUuid': typeof AuthenticatedProjectsWorkspaceUuidProjectUuidRoute
  '/_authenticated/projects/$projectSlug/': typeof AuthenticatedProjectsProjectSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/login'
    | '/account'
    | '/dashboard'
    | '/prompts'
    | '/uploads'
    | '/workspaces'
    | '/dev/ai-suggestions-preview'
    | '/dev/app-shell-preview'
    | '/dev/chat-preview'
    | '/dev/design-system'
    | '/dev/viewer-overlays'
    | '/docfiller/$documentId'
    | '/docfiller/chats'
    | '/public/docfiller/$shareToken'
    | '/docfiller/'
    | '/projects/'
    | '/projects/$projectSlug/context'
    | '/projects/$projectSlug/members'
    | '/projects/$projectSlug/prompts'
    | '/projects/$workspaceUuid/$projectUuid'
    | '/projects/$projectSlug/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/login'
    | '/account'
    | '/dashboard'
    | '/prompts'
    | '/uploads'
    | '/workspaces'
    | '/dev/ai-suggestions-preview'
    | '/dev/app-shell-preview'
    | '/dev/chat-preview'
    | '/dev/design-system'
    | '/dev/viewer-overlays'
    | '/docfiller/$documentId'
    | '/docfiller/chats'
    | '/public/docfiller/$shareToken'
    | '/docfiller'
    | '/projects'
    | '/projects/$projectSlug/context'
    | '/projects/$projectSlug/members'
    | '/projects/$projectSlug/prompts'
    | '/projects/$workspaceUuid/$projectUuid'
    | '/projects/$projectSlug'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/callback'
    | '/login'
    | '/_authenticated/account'
    | '/_authenticated/dashboard'
    | '/_authenticated/prompts'
    | '/_authenticated/uploads'
    | '/_authenticated/workspaces'
    | '/dev/ai-suggestions-preview'
    | '/dev/app-shell-preview'
    | '/dev/chat-preview'
    | '/dev/design-system'
    | '/dev/viewer-overlays'
    | '/_authenticated/docfiller/$documentId'
    | '/_authenticated/docfiller/chats'
    | '/public/docfiller/$shareToken'
    | '/_authenticated/docfiller/'
    | '/_authenticated/projects/'
    | '/_authenticated/projects/$projectSlug/context'
    | '/_authenticated/projects/$projectSlug/members'
    | '/_authenticated/projects/$projectSlug/prompts'
    | '/_authenticated/projects/$workspaceUuid/$projectUuid'
    | '/_authenticated/projects/$projectSlug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  LoginRoute: typeof LoginRoute
  DevAiSuggestionsPreviewRoute: typeof DevAiSuggestionsPreviewRoute
  DevAppShellPreviewRoute: typeof DevAppShellPreviewRoute
  DevChatPreviewRoute: typeof DevChatPreviewRoute
  DevDesignSystemRoute: typeof DevDesignSystemRoute
  DevViewerOverlaysRoute: typeof DevViewerOverlaysRoute
  PublicDocfillerShareTokenRoute: typeof PublicDocfillerShareTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/viewer-overlays': {
      id: '/dev/viewer-overlays'
      path: '/dev/viewer-overlays'
      fullPath: '/dev/viewer-overlays'
      preLoaderRoute: typeof DevViewerOverlaysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/design-system': {
      id: '/dev/design-system'
      path: '/dev/design-system'
      fullPath: '/dev/design-system'
      preLoaderRoute: typeof DevDesignSystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/chat-preview': {
      id: '/dev/chat-preview'
      path: '/dev/chat-preview'
      fullPath: '/dev/chat-preview'
      preLoaderRoute: typeof DevChatPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/app-shell-preview': {
      id: '/dev/app-shell-preview'
      path: '/dev/app-shell-preview'
      fullPath: '/dev/app-shell-preview'
      preLoaderRoute: typeof DevAppShellPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/ai-suggestions-preview': {
      id: '/dev/ai-suggestions-preview'
      path: '/dev/ai-suggestions-preview'
      fullPath: '/dev/ai-suggestions-preview'
      preLoaderRoute: typeof DevAiSuggestionsPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/workspaces': {
      id: '/_authenticated/workspaces'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof AuthenticatedWorkspacesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/uploads': {
      id: '/_authenticated/uploads'
      path: '/uploads'
      fullPath: '/uploads'
      preLoaderRoute: typeof AuthenticatedUploadsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/prompts': {
      id: '/_authenticated/prompts'
      path: '/prompts'
      fullPath: '/prompts'
      preLoaderRoute: typeof AuthenticatedPromptsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/docfiller/': {
      id: '/_authenticated/docfiller/'
      path: '/docfiller'
      fullPath: '/docfiller/'
      preLoaderRoute: typeof AuthenticatedDocfillerIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/public/docfiller/$shareToken': {
      id: '/public/docfiller/$shareToken'
      path: '/public/docfiller/$shareToken'
      fullPath: '/public/docfiller/$shareToken'
      preLoaderRoute: typeof PublicDocfillerShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/docfiller/chats': {
      id: '/_authenticated/docfiller/chats'
      path: '/docfiller/chats'
      fullPath: '/docfiller/chats'
      preLoaderRoute: typeof AuthenticatedDocfillerChatsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/docfiller/$documentId': {
      id: '/_authenticated/docfiller/$documentId'
      path: '/docfiller/$documentId'
      fullPath: '/docfiller/$documentId'
      preLoaderRoute: typeof AuthenticatedDocfillerDocumentIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectSlug/': {
      id: '/_authenticated/projects/$projectSlug/'
      path: '/projects/$projectSlug'
      fullPath: '/projects/$projectSlug/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectSlugIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$workspaceUuid/$projectUuid': {
      id: '/_authenticated/projects/$workspaceUuid/$projectUuid'
      path: '/projects/$workspaceUuid/$projectUuid'
      fullPath: '/projects/$workspaceUuid/$projectUuid'
      preLoaderRoute: typeof AuthenticatedProjectsWorkspaceUuidProjectUuidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectSlug/prompts': {
      id: '/_authenticated/projects/$projectSlug/prompts'
      path: '/projects/$projectSlug/prompts'
      fullPath: '/projects/$projectSlug/prompts'
      preLoaderRoute: typeof AuthenticatedProjectsProjectSlugPromptsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectSlug/members': {
      id: '/_authenticated/projects/$projectSlug/members'
      path: '/projects/$projectSlug/members'
      fullPath: '/projects/$projectSlug/members'
      preLoaderRoute: typeof AuthenticatedProjectsProjectSlugMembersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectSlug/context': {
      id: '/_authenticated/projects/$projectSlug/context'
      path: '/projects/$projectSlug/context'
      fullPath: '/projects/$projectSlug/context'
      preLoaderRoute: typeof AuthenticatedProjectsProjectSlugContextRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedPromptsRoute: typeof AuthenticatedPromptsRoute
  AuthenticatedUploadsRoute: typeof AuthenticatedUploadsRoute
  AuthenticatedWorkspacesRoute: typeof AuthenticatedWorkspacesRoute
  AuthenticatedDocfillerDocumentIdRoute: typeof AuthenticatedDocfillerDocumentIdRoute
  AuthenticatedDocfillerChatsRoute: typeof AuthenticatedDocfillerChatsRoute
  AuthenticatedDocfillerIndexRoute: typeof AuthenticatedDocfillerIndexRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedProjectsProjectSlugContextRoute: typeof AuthenticatedProjectsProjectSlugContextRoute
  AuthenticatedProjectsProjectSlugMembersRoute: typeof AuthenticatedProjectsProjectSlugMembersRoute
  AuthenticatedProjectsProjectSlugPromptsRoute: typeof AuthenticatedProjectsProjectSlugPromptsRoute
  AuthenticatedProjectsWorkspaceUuidProjectUuidRoute: typeof AuthenticatedProjectsWorkspaceUuidProjectUuidRoute
  AuthenticatedProjectsProjectSlugIndexRoute: typeof AuthenticatedProjectsProjectSlugIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedPromptsRoute: AuthenticatedPromptsRoute,
  AuthenticatedUploadsRoute: AuthenticatedUploadsRoute,
  AuthenticatedWorkspacesRoute: AuthenticatedWorkspacesRoute,
  AuthenticatedDocfillerDocumentIdRoute: AuthenticatedDocfillerDocumentIdRoute,
  AuthenticatedDocfillerChatsRoute: AuthenticatedDocfillerChatsRoute,
  AuthenticatedDocfillerIndexRoute: AuthenticatedDocfillerIndexRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
  AuthenticatedProjectsProjectSlugContextRoute:
    AuthenticatedProjectsProjectSlugContextRoute,
  AuthenticatedProjectsProjectSlugMembersRoute:
    AuthenticatedProjectsProjectSlugMembersRoute,
  AuthenticatedProjectsProjectSlugPromptsRoute:
    AuthenticatedProjectsProjectSlugPromptsRoute,
  AuthenticatedProjectsWorkspaceUuidProjectUuidRoute:
    AuthenticatedProjectsWorkspaceUuidProjectUuidRoute,
  AuthenticatedProjectsProjectSlugIndexRoute:
    AuthenticatedProjectsProjectSlugIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CallbackRoute: CallbackRoute,
  LoginRoute: LoginRoute,
  DevAiSuggestionsPreviewRoute: DevAiSuggestionsPreviewRoute,
  DevAppShellPreviewRoute: DevAppShellPreviewRoute,
  DevChatPreviewRoute: DevChatPreviewRoute,
  DevDesignSystemRoute: DevDesignSystemRoute,
  DevViewerOverlaysRoute: DevViewerOverlaysRoute,
  PublicDocfillerShareTokenRoute: PublicDocfillerShareTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
